'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461 from "./presto.types$-Directive-Description$$anon$61.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462 from "./presto.types$-Directive-Description$$anon$62.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveDescription$() {
  this.c4E = null;
  this.c4F = false;
  this.c4C = null;
  this.c4D = false;
  this.c4I = null;
  this.c4J = false;
  this.c4G = null;
  this.c4H = false;
  this.c4K = null;
  this.c4L = false;
}
export { $c_Lpresto_types$DirectiveDescription$ as $c_Lpresto_types$DirectiveDescription$ };
$p = $c_Lpresto_types$DirectiveDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveDescription$;
/** @constructor */
function $h_Lpresto_types$DirectiveDescription$() {
}
export { $h_Lpresto_types$DirectiveDescription$ as $h_Lpresto_types$DirectiveDescription$ };
$h_Lpresto_types$DirectiveDescription$.prototype = $p;
$p.cHn = (function() {
  if ((!this.c4F)) {
    this.c4E = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c4F = true;
  }
  return this.c4E;
});
$p.v3 = (function() {
  if ((!this.c4D)) {
    this.c4C = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c4D = true;
  }
  return this.c4C;
});
$p.cI8 = (function() {
  if ((!this.c4J)) {
    this.c4I = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4J = true;
  }
  return this.c4I;
});
$p.cHU = (function() {
  if ((!this.c4H)) {
    this.c4G = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461.$c_Lpresto_types$DirectiveDescription$$anon$61(this);
    this.c4H = true;
  }
  return this.c4G;
});
$p.cIp = (function() {
  if ((!this.c4L)) {
    this.c4K = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462.$c_Lpresto_types$DirectiveDescription$$anon$62(this);
    this.c4L = true;
  }
  return this.c4K;
});
var $d_Lpresto_types$DirectiveDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveDescription$, "presto.types$DirectiveDescription$", ({
  ZP: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveDescription$ as $d_Lpresto_types$DirectiveDescription$ };
var $n_Lpresto_types$DirectiveDescription$;
function $m_Lpresto_types$DirectiveDescription$() {
  if ((!$n_Lpresto_types$DirectiveDescription$)) {
    $n_Lpresto_types$DirectiveDescription$ = new $c_Lpresto_types$DirectiveDescription$();
  }
  return $n_Lpresto_types$DirectiveDescription$;
}
export { $m_Lpresto_types$DirectiveDescription$ as $m_Lpresto_types$DirectiveDescription$ };
//# sourceMappingURL=presto.types$-Directive-Description$.js.map
